import styled from "styled-components";
import {getMapKey, getPaddingsClassFromData, getPropSafely} from "@/utils/utils";
import SingleQuestionAndAnswer from "@/components/FAQ/SingleQuestionAndAnswer";
import useFilterData from "@/hooks/useFIlterData";
import {useState} from "react";
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock";

const StyledQuestionsWrapper = styled.div`
`

export default function FAQ({data}) {
	const paddings = getPaddingsClassFromData(data)
	const useGlobalContext = getPropSafely(data, 'useGlobalContext', false)
	const allFaqs = getPropSafely(data, 'faqs', [])
	const contextData = useFilterData(allFaqs, useGlobalContext)
	const questions = getPropSafely(contextData, 'question', [])
	const [activeIndex, setActiveIndex] = useState(null);

	const handleUpdateActiveItem = (index) => {
		setActiveIndex(index)
	}

	return (
		<section className={`${paddings}`}>
			<HeaderDescriptionBlock headerDescription={contextData?.headerDescription || null} />
			<StyledQuestionsWrapper>
				{questions.map((item, index) => {
					const question = getPropSafely(item, 'question');
					const answer = getPropSafely(item, 'answer');
					return (
						<SingleQuestionAndAnswer
							key={getMapKey(item, index)}
							index={index}
							activeIndex={activeIndex}
							handleUpdateActiveItem={handleUpdateActiveItem}
							question={question}
							answer={answer}
						/>
					)
				})}
			</StyledQuestionsWrapper>
		</section>
	)
}
